import { useState, useEffect } from 'react';
import { getProblemsDiscoveryFilters } from '../data/problemsApi';
import { useAuth } from '../context/AuthContext';

export const useProblemsFilters = (currentFilters = {}) => {
  const { currentUser } = useAuth();
  
  const [filterData, setFilterData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFilters = async () => {
    const clientId = currentUser?.customer_id;
    
    if (!clientId) {
      setFilterData(null);
      setLoading(false);
      return;
    }
    
    setLoading(true);
    setError(null);

    try {
      const apiFilters = { ...currentFilters };
      if (apiFilters.route && !apiFilters.routes) {
        apiFilters.routes = apiFilters.route;
      }
      const response = await getProblemsDiscoveryFilters(clientId, apiFilters);
      setFilterData(response);
    } catch (err) {
      console.error('❌ [useProblemsFilters] Error fetching problems filters:', err);
      setError(err.message || 'Failed to fetch filter options');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFilters();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?.customer_id, currentFilters]);

  return {
    filterData,
    loading,
    error,
    refetch: fetchFilters
  };
};
